import { useEffect } from 'react';
// layouts
import Layout from '../layouts';
//auth
import { useRouter } from 'next/router';
// components
import LoadingScreen from '../components/LoadingScreen';
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------
// DEFEITO CORRIGIDO: RootStyle/ContentStyle (styled do MUI) existiam neste
// arquivo mas nunca eram usados no JSX - so a LoadingScreen era renderizada.
// Codigo morto que arrastava @mui/material/styles para uma pagina que nao
// precisa de nenhum estilo proprio. Removidos.
// ----------------------------------------------------------------------

IndexPage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function IndexPage() {

  const { isAuthenticated, setToken, isInitialized } = useAuth();
  const { push,
    //pathname,
   //  query
     } = useRouter();

  // const { token } = query;

  // useEffect(() => {
  //   if(token){
  //     setToken(token)
  //   }
  // }, [token])

  // CORRIGIDO: o redirect era feito DURANTE O RENDER.
  //
  // No Next isso funcionava por acidente (router.push era so um efeito colateral
  // solto). No react-router, chamar navigate() durante o render e ignorado e gera
  // o aviso "You should call navigate() in a React.useEffect(), not when your
  // component is first rendered" - resultado: a tela ficava presa no
  // <LoadingScreen /> para sempre, sem nunca redirecionar.
  //
  // Efeito colateral em render tambem e incorreto no React em geral (roda duas
  // vezes em StrictMode e pode ser descartado), entao a correcao vale para os
  // dois roteadores.
  useEffect(() => {
    if (!isInitialized) return;
    if (isAuthenticated) push('/dashboard/app/');
    else push('/auth/login');
  }, [isInitialized, isAuthenticated, push]);

  return (
    <LoadingScreen />
  );
}
